import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-microsoft-azure',
  templateUrl: './microsoft-azure.component.html',
  styleUrls: ['./microsoft-azure.component.sass']
})
export class MicrosoftAzureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
